export class Payment
{
  smartcard: string;
  basketid: string;
  firstname: string;
  lastname: string;
  duedate: string;
  currentbouquet: string
  merchantReference: string;
  amount: string;
  currency: string;  
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/paymentmodel.ts